<script lang="ts">
	export let label: string = "";
	export let helperText: string = "";
	export let error: string | string[] | null | undefined | boolean = "";
	export let warning: string | string[] | null = "";
	export let icon: string = "";
	export let loading = false;
	export let focused = false;
	export let disabled = false;
	export let helperTextWhiteSpace = true;
</script>

<div
	data-focused={focused ? "true" : "false"}
	data-error={error ? "true" : "false"}
	class="{$$props.class} group/input relative
	"
>
	<div
		class="flex w-full items-center justify-start text-gray-400
		{error && 'text-red-400  group-data-[focused=true]/input:!text-red-600'}
		{warning && 'text-yellow-400  group-data-[focused=true]/input:!text-yellow-600'}
		{focused && 'text-secondary'}
	
	"
	>
		<div class="relative w-full {disabled && 'opacity-40'}">
			<div
				class="flex w-full flex-col-reverse justify-center
			{icon && 'pl-8'}
		"
			>
				<div
					class="text-start text-xs text-current {helperTextWhiteSpace &&
						'min-h-3'}"
				>
					{#if error || warning || helperText}
						{#if error}
							<div class="mb-2">
								{#if Array.isArray(error)}
									{#each error as err}
										{err}
									{/each}
								{:else}
									{error}
								{/if}
							</div>
						{:else if warning}
							<div class="mb-2">
								{#if Array.isArray(warning)}
									{#each warning as err}
										{err}
									{/each}
								{:else}
									{warning}
								{/if}
							</div>
						{:else if helperText}
							<div class="mb-2">
								{helperText}
							</div>
						{/if}
					{/if}
				</div>

				{#if !loading}
					<slot />
				{:else}
					<div
						class="bg-surface-700 absolute flex h-8 w-full items-center px-2 opacity-50"
					>
						Radial load
					</div>
				{/if}

				{#if icon}
					<span
						class="absolute left-0 mr-2
				"
						>{icon}
					</span>
				{/if}

				<label for="input" class="mb-0.5 text-start text-sm">
					{label}
				</label>
			</div>
		</div>
	</div>
	<slot name="footer" />
	<slot name="popper" />
</div>
